import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Pastille',
  props: {
    price: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    }
  }
};